import { useEffect, useState } from "react";
import Input from "../../../Components/Input";
import Radio from "../../../Components/Radio";
import Select from "../../../Components/Select";

const IncentiveModal = ({ register, errors }) => {
	return (
		<>
			<div className="mb-5">
				<label htmlFor="name" className="block mb-3">
					Project Type <span className="text-red-500">*</span>
				</label>
				<Input
					id="name"
					placeholder="Input Project Type"
					required
					type="text"
					{...register("name")}
					errors={errors?.name?.message}
				/>
			</div>
			<div className="mb-5">
				<label htmlFor="name" className="block mb-3">
					Bonus <span className="text-red-500">*</span>
				</label>
				<Input
					id="bonus"
					placeholder="Input Bonus"
					required
					type="number"
					{...register("bonus", { valueAsNumber: true })}
					errors={errors?.bonus?.message}
				/>
			</div>
		</>
	);
};

export default IncentiveModal;
